import React, { useEffect } from "react";
import { Row } from "react-bootstrap";
import BlocksyncLogo from "../assets/blocksync-logo.png";
import PooCoin from "../assets/poocoin-2.png";
import RugSeekers from "../assets/rug-seekers-partner.png";
import SolidGroup from "../assets/solid-group.svg";
import Exchange from "../assets/exchange.png";
import ExnetworkCapital from "../assets/exnetwork_capital.jpg";
import GfxE from "../assets/gfx-e.png";
import Help1 from "../assets/help-1.png";
import Help2 from "../assets/help-2.png";
import Help3 from "../assets/help-3.png";
import Help4 from "../assets/help-4.png";
import Buff from "../assets/buff.jpg";
import Shem from "../assets/shem.jpg";
import Black from "../assets/black.jpg";
import Dizzy from "../assets/dizzy.jpg";
import Neander from "../assets/neander.jpg";
import ElmoJones from "../assets/elmojones.jpg";
import Pancake from "../assets/pancake-swap.png";
import Partner1 from "../assets/partner-1.png";
import Roadmap from "../assets/roadmap.jpg";
import TrustPlatform from "../assets/trust_platform.png";
import X21 from "../assets/x21.png";
import Yield from "../assets/yield.png";
import { Link } from "react-router-dom";

import Seo from "../components/seo";

const Landing = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Seo pageTitle="Home"></Seo>
      <div className="pp-homepage">
        <div className="pp-home-banner">
          <div className="container">
            <h1
              className="text-center text-uppercase"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              ShieldPad is one of the first decentralized IDO Platforms on the
              Binance Chain Network
            </h1>
            <Row className="justify-content-center">
              <div className="col-md-8">
                <p
                  data-aos="fade-up"
                  data-aos-delay="200"
                  style={{ color: "#ff  f" }}
                >
                  ShieldPad is the first LaunchPad in the world to introduce a
                  multi-signature liquidity lock, offering the ultimate security
                  to the investors.
                </p>
              </div>
            </Row>
            <div className="mt-4">
              <Link
                data-aos="fade-up"
                data-aos-delay="300"
                className="btn btn-primary btn-lg me-3"
                to={"/projects"}
              >
                <i className="fab fa-hotjar me-2" aria-hidden={true}></i>
                Projects
              </Link>
              <a
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary btn-pancake btn-lg btn-buy-on me-3"
                href="https://pancakeswap.finance/swap?outputCurrency=0xf2e00684457de1a3c87361bc4bfe2de92342306c"
              >
                <b
                  className="d-flex align-items-center justify-content-center"
                  style={{ whiteSpace: "nowrap" }}
                >
                  Buy on&nbsp;
                  <img alt="" src={Pancake} height="20" />
                  &nbsp;Pancake Swap
                </b>
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                data-aos="fade-up"
                data-aos-delay="400"
                className="btn btn-primary btn-lg me-3"
                href="https://docs.google.com/forms/d/e/1FAIpQLSdPnDyK24Pa1aAXsGB9MF-6jeNdrUZig_or-_cvj7BqdMFeug/viewform?vc=0&c=0&w=1&flr=0"
              >
                Apply for IDO
              </a>
            </div>
            <div className="mt-5 text-center">
              <a
                className="btn btn-outline-primary btn-sm"
                href="https://t.me/shieldnetio"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fas fa-paper-plane me-1"></i>
                <span>Join us on Telegram</span>
              </a>
              <a
                className="btn btn-outline-primary btn-sm mx-3"
                href="https://www.youtube.com/channel/UCj1G0dDyzKivFfoVaf1ygAg"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fab fa-youtube me-1"></i>
                <span>Subscribe to our Youtube channel</span>
              </a>
              <a
                className="btn btn-outline-primary btn-sm"
                href="https://twitter.com/ShieldNet_io"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fab fa-twitter me-1"></i>
                <span>Follow our Twitter</span>
              </a>
            </div>
          </div>
        </div>
        <div className="pp-home-partners">
          <div className="container">
            <div className="pp-home-partners-content d-flex align-items-center justify-content-center">
              <h6 className="me-4 mb-0 text-end" style={{ color: "white" }}>
                Our Partners
              </h6>
              <a
                className="me-4 mb-2 mb-lg-0"
                target="_blank"
                rel="noreferrer"
                href="https://poocoin.app/"
                style={{ color: "rgb(42, 90, 218)" }}
              >
                <img height="48" src={PooCoin} alt="partner" />
              </a>
              <a
                className="me-4"
                target="_blank"
                rel="noreferrer"
                href="https://solidgrp.io/"
              >
                <img height="48" src={SolidGroup} alt="partner" />
              </a>
              <a
                className="me-0"
                target="_blank"
                rel="noreferrer"
                href="https://rugseekers.online/"
              >
                <img
                  className="dark-show"
                  height="48"
                  src={RugSeekers}
                  alt="partner"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="pp-home-about pp-section" id="about">
          <div className="container">
            <Row className="justify-content-center text-center">
              <div className="col-lg-6">
                <div className="section-head">
                  <h2 className="title title-xl">ABOUT US</h2>
                </div>
              </div>
            </Row>
          </div>
          <div className="pp-home-about-content pp-section-body mt-4">
            <div className="container">
              <Row className="align-items-center">
                <div
                  className="col-md-6"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <h2>
                    Shield Network strives to become the principal pre-audited
                    cryptocurrency token launchpad.
                  </h2>
                  <p className="lead-s2">
                    Our central purpose is to expose scam projects, create
                    security within the DeFi space, become a trustworthy
                    launchpad and also collaborate with as many as possible
                    anti-rug projects so that we can try and dare to ensure the
                    ultimate crypto security. The most powerful tool that help
                    achieving the ultimate security is knowledge. Knowledge is
                    power, the more you know the less likely it is for you to
                    get scammed or rugged.
                  </p>
                  <h6 className="mt-4">WHY CHOOSE US?</h6>
                  <h2>
                    Just like your everyday investor, we are a group of people
                    who have fallen a victim to scams and rugpulls way too many
                    times.
                  </h2>
                  <p>
                    This project is the solution towards mitigating scams and
                    rugpulls. Our goal is to let investors put their money into
                    new shielded crypto projects with confidence. Shield Network
                    with the usecase of ShieldPad{" "}
                    <b>
                      strives to create a new golden standard in the DeFi
                      community.{" "}
                    </b>
                    A new golden standard, where its completely normal{" "}
                    <b>
                      <i>
                        to be able to invest into a project that is Shielded, a
                        project that is Protected.
                      </i>
                    </b>
                  </p>
                  <p>
                    Creating the DeFi space a safer place is our main goal, out
                    target and our mission.{" "}
                    <b>This is the Next Generation of DeFi! </b>With the
                    usecases we are building, the rules are about the change,
                    the game is about to change.
                  </p>
                </div>
                <div className="col-md-6 text-center">
                  <div
                    className="nk-block-img nk-block-ca"
                    data-aos="fade-up"
                    data-aos-delay="200"
                    style={{ position: "relative" }}
                  >
                    <div className="nk-circle-animation nk-df-center fast"></div>
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#roadmapModal"
                     style={{ background: "none", border: "none" }}
                    >
                      <img
                        id="roadmap_img"
                        alt=""
                        className="shadow rounded dark-show"
                        src={Roadmap}
                        style={{ width: "65%", margin: "auto" }}
                      />
                    </button>
                    {/*<img
                      alt=""
                      className="shadow rounded w-100 light-show"
                      src={scMediumW}
                    />*/}
                  </div>
                </div>
              </Row>
            </div>
          </div>
        </div>
        <div className="pp-home-how-it-work pp-section pt-3" id="how-it-work">
          <div className="container">
            <Row className="justify-content-center text-center">
              <div className="col-lg-8">
                <div className="section-head">
                  <h2
                    className="title title-xl"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    title=""
                  >
                    THE SHIELD NETWORK TIERED SYSTEM
                  </h2>
                  <p data-aos="fade-up" data-aos-delay="200" className="mt-3">
                    The Shield Network will showcase a fixed tier system based
                    on the number of tokens held.
                  </p>
                </div>
              </div>
            </Row>
          </div>
          <div className="pp-home-how-it-work-content pp-section-body">
            <div className="container">
              <div className="text-center mb-5">
                <h3
                  className="text-uppercase"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <b>Round 1 - Allocation Round</b>
                </h3>
              </div>
              <Row className="mb-3">
                <div
                  className="col-md-12 col-lg-4"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="pricing-table text-center">
                    <Row className="">
                      <div className="col-12">
                        <h3 className="text-warning">Guardian Launch</h3>
                        <h2 className="text-warning">Tier 1</h2>
                      </div>
                      <div className="col-12">
                        <hr />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          All token projects launched in Tier 1 are guaranteed
                          by Shield to be 100% safe.
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          Projects will be required to have their lead developer
                          undergo KYC verification to Shield.
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          Projects will be audited and deployed by Shield.
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          Projects will have development funds held by Shield.
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          Shield will provide 24/7 developer support and a
                          marketing manager for project launches.
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          Tier 1 projects will only be accessible to new
                          investors who hold a minimum (to be determined closer
                          to launch) number of Shield Network tokens.
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0"></p>
                        <br />
                      </div>
                      <div className="col-12">
                        <hr />
                      </div>
                      <div className="col-12">
                        <button
                          type="button"
                          className="btn btn-primary btn-lg"
                        >
                          Learn more
                        </button>
                      </div>
                    </Row>
                  </div>
                </div>
                <div
                  className="col-md-12 col-lg-4"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div className="pricing-table text-center">
                    <Row className="">
                      <div className="col-12">
                        <h3 className="text-warning">Audited Launch</h3>
                        <h2 className="text-warning">Tier 2</h2>
                      </div>
                      <div className="col-12">
                        <hr />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          All token projects launched in Tier 2 are meticulously
                          and methodically audited by Shield.
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          Projects will be required to have their lead developer
                          undergo KYC verification to Shield.
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          Project audits will ensure that the contract is safe
                          and the tokenomics work as marketed.
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          Projects will have time-locked development funds to
                          prevent "liquidity stripping".
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          Tier 2 projects will only be accessible to new
                          investors who hold a minimum (to be determined closer
                          to launch) number of Shield Network tokens.
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0"></p>
                        <br />
                      </div>

                      <div className="col-12">
                        <p className="light thin mb-0"></p>
                        <br />
                      </div>
                      <div className="col-12">
                        <hr />
                      </div>
                      <div className="col-12">
                        <button
                          type="button"
                          className="btn btn-primary btn-lg"
                        >
                          Learn more
                        </button>
                      </div>
                    </Row>
                  </div>
                </div>
                <div
                  className="col-md-12 col-lg-4"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="pricing-table text-center">
                    <Row className="">
                      <div className="col-12">
                        <h3 className="text-warning">Decentralized Launch</h3>
                        <h2 className="text-warning">Tier 3</h2>
                      </div>
                      <div className="col-12">
                        <hr />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          All token projects launched in Tier 3 are completely
                          decentralized. Shield recommends that potential
                          investors do their own research before investing.
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          Projects will have 50% of listing fees used for Shield
                          Network development and 50% of listing fees used for
                          buying/burning Shield Network tokens.
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0">
                          Tier 3 projects are open to all new investors with no
                          minimum required holding of Shield Network tokens.
                        </p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0"></p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0"></p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0"></p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0"></p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0"></p>
                        <br />
                      </div>
                      <div className="col-12">
                        <p className="light thin mb-0"></p>
                        <br />
                      </div>
                      <div className="col-12">
                        <hr />
                      </div>
                      <div className="col-12">
                        <button
                          type="button"
                          className="btn btn-primary btn-lg"
                        >
                          Learn more
                        </button>
                      </div>
                    </Row>
                  </div>
                </div>

                <p className="text-center">
                  In the first round, called the “Allocation Round”, users can
                  purchase the amount allotted to them based on their tier.
                </p>
              </Row>
            </div>
          </div>
        </div>
        <div className="pp-home-about pp-section pt-0" id="next-defi">
          <div className="container">
            <Row className="justify-content-center text-center">
              <div className="col-lg-6">
                <div className="section-head">
                  <h3 className="text-uppercase">
                    <strong>The next generation defi</strong>
                  </h3>
                </div>
              </div>
            </Row>
          </div>
          <div className="pp-home-about-content pp-section-body mt-4">
            <div className="container">
              <Row className="align-items-center">
                <div
                  className="col-md-6"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <img src={GfxE} className="w-100" alt="" />
                </div>
                <div
                  className="col-md-6"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <p>
                    The ShieldPad auditing platform has a multi-faceted
                    investment value. First and foremost, the ShieldPad will be
                    a safe and trusted platform for investors to find project
                    that have been thoroughly vetted before reaching the market.
                    Secondly, holders are going to be able to access the IDO
                    offerings on our pre-audited launch platform. There will be
                    3 different tiers, Guardian, Audited &amp; Decentralized
                    launch. The different IDO tiers will be accessible to
                    investors a specific minimum amount of Shield Network
                    tokens. Next, it will function as a marketing tool for new
                    projects due to the large Shield Network investor base. And
                    all the partners that Shield Network is partnered withat
                    that fully trust in the project and share out launches in
                    their groups too. Finally, it provides the Shield Network
                    project with an income stream via listing fees to fund other
                    aspects of the project and the marketing. Giving our holders
                    the services and utility functions, growing and expanding of
                    our platform and ecosystem, that only serious and powerful
                    projects can offer to their users. Also 50% of the listing
                    fees will be used to buy and burn Shield Network tokens,
                    which constantly and once and forever increases the price
                    floor of the token.
                  </p>
                  <p className="mt-3">
                    <b className="how-it-work-heading">
                      The next generation use-case is not only going to shine
                      with ShieldPad and everything that it has to offer, but
                      rather the next generation of Defi starts with our future
                      upcoming use case "The ShieldTracker"!
                    </b>
                  </p>
                </div>
              </Row>
            </div>
          </div>
        </div>
        <div className="pp-home-advisors pp-section py-3" id="advisor">
          <div className="container">
            <Row className="justify-content-center text-center">
              <div className="col-lg-6">
                <div className="section-head">
                  <h2
                    className="title title-xl"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    title=""
                  >
                    OUR TEAM
                  </h2>
                  <p data-aos="fade-up" data-aos-delay="200" className="mt-3">
                    Our core team members.
                  </p>
                </div>
              </div>
            </Row>
          </div>
          <div className="pp-home-advisors-content pp-section-body">
            <div className="container">
              <Row className="justify-content-center">
                <div
                  className="col-md-4"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="team team-s5">
                    <div className="team-photo team-photo-s1">
                      <img src={Buff} alt="team" className="no-bdrs" />
                      <a
                        href="#"
                        /*data-bs-toggle="modal"*/
                        data-bs-target="#team-popup-1"
                        className="team-show content-popup"
                        data-overlay="bg-grad-alt"
                      >
                        Metamask
                      </a>
                    </div>
                    <h5 className="team-name title title-md">@Bufftown</h5>
                    <span className="team-position">
                      CEO &amp; Financial manager
                    </span>
                    <ul className="team-social team-social-vr team-social-s2">
                      {/* <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="#"
                          >
                            <em className="fab fa-telegram"></em>
                          </a>
                        </li>
                        <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="#"
                          >
                            <em className="fab fa-linkedin-in"></em>
                          </a>
                        </li> */}
                    </ul>
                  </div>
                </div>
                <div
                  className="col-md-4"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div className="team team-s5">
                    <div className="team-photo team-photo-s1">
                      <img src={Shem} alt="team" className="no-bdrs" />
                      <a
                        href="#"
                        /*data-bs-toggle="modal"*/
                        data-bs-target="#team-popup-2"
                        className="team-show content-popup"
                        data-overlay="bg-grad-alt"
                      >
                        More info
                      </a>
                    </div>
                    <h5 className="team-name title title-md">
                      @Shemhamfaraash
                    </h5>
                    <span className="team-position">
                      Co-Founder, CEO, CTO &amp; Developer
                      <br />
                    </span>
                    <ul className="team-social team-social-vr team-social-s2">
                      {/* <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="#"
                          >
                            <em className="fab fa-telegram"></em>
                          </a>
                        </li>
                        <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="#"
                          >
                            <em className="fab fa-twitter"></em>
                          </a>
                        </li>
                        <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="#"
                          >
                            <em className="fab fa-linkedin-in"></em>
                          </a>
                        </li> */}
                    </ul>
                  </div>
                </div>
                <div
                  className="col-md-4"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  <div className="team team-s5">
                    <div className="team-photo team-photo-s1">
                      <img src={Neander} alt="team" className="no-bdrs" />
                      <a
                        href="#"
                        /*d*/ ata-bs-toggle="modal"
                        data-bs-target="#team-popup-3"
                        className="team-show content-popup"
                        data-overlay="bg-grad-alt"
                      >
                        More info
                      </a>
                    </div>
                    <h5 className="team-name title title-md">
                      @Neander_Shield
                    </h5>
                    <span className="team-position">Co-Founder, CEO &amp; Developer</span>
                    <ul className="team-social team-social-vr team-social-s2">
                      {/* <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.linkedin.com/in/ian-friend-bb949657/"
                          >
                            <em className="fab fa-linkedin-in">.</em>
                          </a>
                        </li> */}
                    </ul>
                  </div>
                </div>
                <div
                  className="col-md-4"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  <div className="team team-s5">
                    <div className="team-photo team-photo-s1">
                      <img src={Dizzy} alt="team" className="no-bdrs" />
                      <a
                        href="#"
                        /*data-bs-toggle="modal"*/
                        data-bs-target="#team-popup-4"
                        className="team-show content-popup"
                        data-overlay="bg-grad-alt"
                      >
                        More info
                      </a>
                    </div>
                    <h5 className="team-name title title-md">@DizzY991</h5>
                    <span
                      className="team-position"
                      style={{ minHeight: "5.5rem" }}
                    >
                      Graphics Designer
                    </span>
                    <ul className="team-social team-social-vr team-social-s2">
                      {/* <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="#"
                          >
                            <em className="fab fa-twitter">.</em>
                          </a>
                        </li>
                        <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="#"
                          >
                            <em className="fab fa-linkedin-in">.</em>
                          </a>
                        </li> */}
                    </ul>
                  </div>
                </div>
                <div
                  className="col-md-4"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div className="team team-s5">
                    <div className="team-photo team-photo-s1">
                      <img
                        src={ElmoJones}
                        alt="team"
                        className="no-bdrs"
                        height="184px"
                      />
                      <a
                        href="#"
                        /*data-bs-toggle="modal"*/
                        data-bs-target="#team-popup-6"
                        className="team-show content-popup"
                        data-overlay="bg-grad-alt"
                      >
                        .
                      </a>
                    </div>
                    <h5 className="team-name title title-md">@elmojones</h5>
                    <span
                      className="team-position"
                      style={{ minHeight: "5.5rem" }}
                    >
                      Main Developer
                    </span>
                    <br />
                    <ul className="team-social team-social-vr team-social-s2">
                      {/* <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="#"
                          >
                            <em className="fab fa-twitter"></em>
                          </a>
                        </li>
                        <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="#"
                          >
                            <em className="fab fa-linkedin-in"></em>
                          </a>
                        </li> */}
                    </ul>
                  </div>
                </div>
                <div
                  className="col-md-4"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div className="team team-s5">
                    <div className="team-photo team-photo-s1">
                      <img
                        src={Black}
                        alt="team"
                        className="no-bdrs"
                        height="184px"
                      />
                      <a
                        href="#"
                        /*data-bs-toggle="modal"*/
                        data-bs-target="#team-popup-6"
                        className="team-show content-popup"
                        data-overlay="bg-grad-alt"
                      >
                        .
                      </a>
                    </div>
                    <h5 className="team-name title title-md">@B L A C K</h5>
                    <span
                      className="team-position"
                      style={{ minHeight: "5.5rem" }}
                    >
                      Moderator Manager, Moderator &amp; Kebab Master
                    </span>
                    <br />
                    <ul className="team-social team-social-vr team-social-s2">
                      {/* <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="#"
                          >
                            <em className="fab fa-twitter">.</em>
                          </a>
                        </li>
                        <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="#"
                          >
                            <em className="fab fa-linkedin-in"></em>
                          </a>
                        </li> */}
                    </ul>
                  </div>
                </div>
                {/* <div
                    className="col-md-4"
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    <div className="team team-s5">
                      <div className="team-photo team-photo-s1">
                        <img
                          src={User}
                          alt="team"
                          className="no-bdrs"
                          height="184px"
                        />
                        <a
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#team-popup-6"
                          className="team-show content-popup"
                          data-overlay="bg-grad-alt"
                        >
                          .
                        </a>
                      </div>
                      <h5 className="team-name title title-md">TIM FROST</h5>
                      <span
                        className="team-position"
                        style={{ minHeight: "5.5rem" }}
                      >
                        CEO and co-founder
                        <br />
                        of YIELD App
                      </span>
                      <br />
                      <ul className="team-social team-social-vr team-social-s2">
                        <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="#"
                          >
                            <em className="fab fa-twitter"></em>
                          </a>
                        </li>
                        <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="#"
                          >
                            <em className="fab fa-linkedin-in"></em>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div> */}
              </Row>
            </div>
          </div>
        </div>
        <div className="pp-home-contact pp-section py-5" id="contact">
          <div className="container">
            <Row className="justify-content-center text-center">
              <div className="col-lg-6">
                <div className="section-head">
                  <h2
                    className="title title-xl"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    title=""
                  >
                    CONTACT
                  </h2>
                </div>
              </div>
            </Row>
          </div>
          <div className="pp-home-contact-content pp-section-body mt-5">
            <div className="container">
              <Row className="justify-content-center align-items-center gutter-vr-50px">
                <div className="col-lg-5 text-center order-lg-first">
                  <div
                    className="nk-block-contact nk-block-contact-s1"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <ul className="contact-list ps-1">
                      <li data-aos="fade-up" data-aos-delay="300">
                        <em className="contact-icon fas fa-headset"></em>
                        <div className="contact-text">
                          <a href="mailto:info@shieldnetwork.io">
                            <span>info@shieldnetwork.io</span>
                          </a>
                        </div>
                      </li>
                      <li data-aos="fade-up" data-aos-delay="400">
                        <em className="contact-icon fa fa-paper-plane"></em>
                        <div className="contact-text">
                          <a
                            href="https://t.me/shieldnetio"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {" "}
                            <span>Join us on Telegram</span>
                          </a>
                        </div>
                      </li>
                      <li data-aos="fade-up" data-aos-delay="400">
                        <em className="contact-icon fab fa-twitter"></em>
                        <div className="contact-text">
                          <a
                            href="https://twitter.com/ShieldNet_io"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {" "}
                            <span>Follow our Twitter</span>
                          </a>
                        </div>
                      </li>
                      <li data-aos="fade-up" data-aos-delay="500">
                        <em className="contact-icon fab fa-reddit"></em>
                        <div className="contact-text">
                          <a
                            href="https://www.reddit.com/r/ShieldNetworkv2/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {" "}
                            <span>Follow our Reddit</span>
                          </a>
                        </div>
                      </li>
                      <li data-aos="fade-up" data-aos-delay="500">
                        <em className="contact-icon fa fa-chart-scatter"></em>
                        <div className="contact-text">
                          <a
                            href="https://poocoin.app/tokens/0xf2e00684457de1a3c87361bc4bfe2de92342306c"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {" "}
                            <span>Chart on PooCoin</span>
                          </a>
                        </div>
                      </li>
                    </ul>
                    <div className="nk-circle-animation nk-df-center white small"></div>
                  </div>
                </div>
              </Row>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="team-popup-1"
          tabIndex="-1"
          aria-labelledby="team-popup-1Label"
          aria-hidden="true"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered pp-modal-team">
            <div className="modal-content">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <div className="modal-body">
                <Row className="mb-3">
                  <div className="col-md-6 text-center">
                    <div className="mb-3 pe-md-3">
                      <img
                        src={Buff}
                        alt="team"
                        className="no-bdrs w-100 borras"
                      />
                    </div>
                    <p className="mb-1">
                      <img
                        src={BlocksyncLogo}
                        alt="team"
                        className="no-bdrs"
                        height="40"
                      />
                    </p>
                    <p>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://blocksync.com/"
                      >
                        https://blocksync.com
                      </a>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <h3>JASPER BYUN</h3>
                    <p style={{ opacity: "0.6" }}>
                      Founder of Blocksync Ventures
                    </p>
                    <p>
                      <a
                        className="me-3"
                        target="_blank"
                        rel="noreferrer"
                        href="https://au.linkedin.com/in/jasperb"
                      >
                        <em className="fab fa-linkedin-in"></em>
                      </a>
                      <a
                        className="me-3"
                        target="_blank"
                        rel="noreferrer"
                        href="https://t.me/JasperBV"
                      >
                        <em className="fab fa-telegram"></em>
                      </a>
                    </p>
                    <hr />
                    <p>
                      Jasper is the founder of Blocksync Ventures and a managing
                      partner at Brilliance Ventures. He has been working with
                      start-ups for over 5 years and has coordinated investments
                      exceeding $50M into world-class distributed technologies
                      projects.
                    </p>
                    <p>
                      He has also guided advisory portfolios to establish key
                      strategic initiatives by securing partnerships, ensuring
                      proper marketing direction, and encompassing overall
                      day-to-day operations.
                    </p>
                  </div>
                </Row>
                <p>
                  We truly believe BSCPAD investors will benefit from this
                  partnership as we can lean on Jasper’s extensive Fintech
                  background and expertise.
                </p>
                <p className="mb-0">
                  Jasper is the first of many partners to be revealed in the
                  upcoming days so keep an eye on the BSCPAD telegram channel
                  for future updates!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="team-popup-2"
          tabIndex="-1"
          aria-labelledby="team-popup-2Label"
          aria-hidden="true"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered pp-modal-team">
            <div className="modal-content">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <div className="modal-body">
                <Row className="mb-3">
                  <div className="col-md-6 text-center">
                    <div className="mb-3 pe-md-3">
                      <img
                        src={Shem}
                        alt="team"
                        className="no-bdrs w-100 borras"
                      />
                    </div>
                    <p className="mb-1">
                      <img
                        src={X21}
                        alt="team"
                        className="no-bdrs"
                        height="40"
                      />
                    </p>
                    <p>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://x21digital.com/"
                      >
                        https://x21digital.com
                      </a>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <h3>LESTER LIM</h3>
                    <p style={{ opacity: "0.6" }}>Founder at X21 Digital</p>
                    <p>
                      <a
                        className="me-3"
                        target="_blank"
                        rel="noreferrer"
                        href="https://sg.linkedin.com/in/lesterlim15"
                      >
                        <em className="fab fa-linkedin-in"></em>
                      </a>
                      <a
                        className="me-3"
                        target="_blank"
                        rel="noreferrer"
                        href="https://t.me/Lesterlim15"
                      >
                        <em className="fab fa-telegram"></em>
                      </a>
                      <a
                        className="me-3"
                        target="_blank"
                        rel="noreferrer"
                        href="https://twitter.com/lesterlim15?lang=en"
                      >
                        <em className="fab fa-twitter"></em>
                      </a>
                    </p>
                    <hr />
                    <p>
                      Lester is the founder of X21 Digital. He incubates and
                      supports promising projects via his marketing experience
                      &amp; vast connections within the blockchain ecosystem.
                      His latest incubation projects include Blank Wallet,
                      DAOventures and Vortex Defi.
                    </p>
                    <p>
                      He focuses on strategic directions, token metrics, and
                      connecting the dots as a Strategic Advisor to other
                      projects by bringing in the RIGHT connections and
                      resources to shortcut their success.
                    </p>
                  </div>
                </Row>
                <p>
                  Also Strategic Advisor to PolkaFoundry, Oddz, Project Inverse,
                  MahaDao &amp; Finxflo.
                </p>
                <p className="mb-0">
                  The BSCPAD team and Lester both share a common love of
                  Blockchain Technology – and are excited to leverage his vast
                  connections to bring mass exposure to BSCPAD. We are excited
                  to be a part of the exclusive X21 Digital portfolio and join
                  the other prestigious projects who have benefited from
                  Lester’s guidance.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="team-popup-3"
          tabIndex="-1"
          aria-labelledby="team-popup-3Label"
          aria-hidden="true"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered pp-modal-team">
            <div className="modal-content">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <div className="modal-body">
                <Row className="mb-3">
                  <div className="col-md-6 text-center">
                    <div className="mb-3 pe-md-3">
                      <img
                        src={Neander}
                        alt="team"
                        className="no-bdrs w-100 borras"
                      />
                    </div>
                    <p className="mb-1">
                      <img
                        src={Partner1}
                        alt="team"
                        className="no-bdrs"
                        height="40"
                      />
                    </p>
                    <p>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://ferrum.network/"
                      >
                        https://ferrum.network/
                      </a>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <h3>IAN FRIEND</h3>
                    <p style={{ opacity: "0.6" }}>
                      Co-Founder and COO at Ferrum Network
                    </p>
                    <p>
                      <a
                        className="me-3"
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.linkedin.com/in/ian-friend-bb949657"
                      >
                        <em className="fab fa-linkedin-in"></em>
                      </a>
                    </p>
                    <hr />
                    <p>
                      Ian Friend is the Co-Founder and COO at Ferrum Network.{" "}
                    </p>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="team-popup-4"
          tabIndex="-1"
          aria-labelledby="team-popup-3Label"
          aria-hidden="true"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered pp-modal-team">
            <div className="modal-content">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <div className="modal-body">
                <Row className="mb-3">
                  <div className="col-md-6 text-center">
                    <div className="mb-3 pe-md-3">
                      <img
                        src={Dizzy}
                        alt="team"
                        className="no-bdrs w-100 borras"
                      />
                    </div>
                    <p className="mb-1">
                      <img
                        src={Exchange}
                        alt="team"
                        className="no-bdrs"
                        style={{ maxWidth: "250px", maxHeight: "40px" }}
                      />
                    </p>
                    <p>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://exchange.bitcoin.com/"
                      >
                        https://exchange.bitcoin.com/
                      </a>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <h3>DANISH CHAUDHRY</h3>
                    <p style={{ opacity: "0.6" }}>
                      CEO at Bitcoin.com Exchange – Entrepreneur, Startup
                      Advisor, Mentor and Investor
                    </p>
                    <p>
                      <a
                        className="me-3"
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.linkedin.com/in/djchaudhry/"
                      >
                        <em className="fab fa-linkedin-in"></em>
                      </a>
                      <a
                        className="me-3"
                        target="_blank"
                        rel="noreferrer"
                        href="https://twitter.com/djchaudhry_"
                      >
                        <em className="fab fa-twitter"></em>
                      </a>
                    </p>
                    <hr />
                    <p>
                      Danish Chaudhry is the CEO of Bitcoin.com Exchange
                      (https://exchange.bitcoin.com/), an up and coming exchange
                      that focuses on bringing the most promising projects to
                      market. He is an active investor and advisor, having
                      backed some of the most prominent projects out there from
                      an early stage such as matic (now polygon), marlin, cere,
                      moonbeam, sifchain, flow, graph and the list goes on.
                    </p>
                    <p>
                      Danish has been in the blockchain space since the early
                      days. He has a background in finance where he was a PM at
                      Blackrock for a number of years, having founded and
                      successfully exited two startups, he's built fintech and
                      insurtech incubators at his previous VC that have produced
                      startups valued at over $2bn.
                    </p>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="team-popup-5"
          tabIndex="-1"
          aria-labelledby="team-popup-3Label"
          aria-hidden="true"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered pp-modal-team">
            <div className="modal-content">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <div className="modal-body">
                <Row className="mb-3">
                  <div className="col-md-6 text-center">
                    <div className="mb-3 pe-md-3">
                      <img
                        src={ElmoJones}
                        alt="team"
                        className="no-bdrs w-100 borras"
                      />
                    </div>
                    <p className="mb-1">
                      <img
                        src={ExnetworkCapital}
                        alt="team"
                        className="no-bdrs"
                        height="40"
                      />
                    </p>
                    <p>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://exnetworkcapital.com/"
                      >
                        https://exnetworkcapital.com
                      </a>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <h3>EXNETWORK CAPITALY</h3>
                    <p style={{ opacity: "0.6" }}>
                      Exnetwork Capital is an investment firm focused on funding
                      and incubating blockchain projects. It is composed of a
                      DAO of different investors all helping out to ensure the
                      portfolio companies' success.
                    </p>
                    <p>
                      <a
                        className="me-3"
                        target="_blank"
                        rel="noreferrer"
                        href="https://twitter.com/exnetworkcap"
                      >
                        <em className="fab fa-twitter"></em>
                      </a>
                    </p>
                    <hr />
                    <p>
                      Exnetwork Capital's incubator program will help mentor
                      BSCPAD and provide support from their network of
                      entrepreneurs who will help take the BSC Launch Pad to new
                      levels. Exnetwork primarily focuses on the decentralized
                      market and can assist with many areas such as token
                      design, fundraising, and marketing. New projects entering
                      the launchpad will be able to glean much knowledge from
                      the Exnetwork Capital team.{" "}
                    </p>
                    <p>
                      We are aligned in supporting the creation and launching of
                      new projects. We aim to help these new BSC projects to
                      succeed and garner the same attention, hype and love as
                      their erc counterparts.
                    </p>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="team-popup-6"
          tabIndex="-1"
          aria-labelledby="team-popup-6Label"
          aria-hidden="true"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered pp-modal-team">
            <div className="modal-content">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <div className="modal-body">
                <Row className=" mb-3">
                  <div className="col-md-6 text-center">
                    <div className="mb-3 pe-md-3">
                      <img
                        src={Black}
                        alt="team"
                        className="no-bdrs w-100 borras"
                      />
                    </div>
                    <p className="mb-1">
                      <img
                        src={Yield}
                        alt="team"
                        className="no-bdrs"
                        height="40"
                      />
                    </p>
                    <p>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.yield.app/"
                      >
                        https://www.yield.app
                      </a>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <h3>TIM FROST</h3>
                    <p style={{ opacity: "0.6" }}>
                      Tim Frost is CEO and co-founder of YIELD App which is one
                      of the fastest growing fintech companies in the crypto
                      space. He has extensive experience in FinTech, marketing,
                      business development, and operations. YIELD App is the
                      third digital finance platform Tim has brought to the
                      market. He was a founding member of the Wirex team and
                      supported operations, business development, and marketing
                      for the first 18 months. Tim also helped bring EQI Bank to
                      the global market as a digital challenger to conventional
                      banking, with an average client AUM of $250,000. Tim's
                      experience in blockchain technology includes early
                      involvement with numerous successful projects including
                      QTUM, NEO, Paxful, Polymath, Selfkey and Everex. Tim has
                      been building crypto and fintech companies since 2014.
                    </p>
                    <p>
                      <a
                        className="me-3"
                        target="_blank"
                        rel="noreferrer"
                        href="https://hk.linkedin.com/in/timfrost55"
                      >
                        <em className="fab fa-linkedin-in"></em>
                      </a>
                      <a
                        className="me-3"
                        target="_blank"
                        rel="noreferrer"
                        href="https://twitter.com/TimYIELD"
                      >
                        <em className="fab fa-twitter"></em>
                      </a>
                    </p>
                    <hr />
                    <p>
                      Adding Tim Frost as a strategic partner and advisor
                      reinforces our commitment to aggressive growth for BSCPAD.
                      Tim will help lead our efforts with his vast experience in
                      FinTech, marketing, business development, and operations.
                      We will be utilizing his expertise in these areas to help
                      lead to even higher customer adoption and expansion into
                      new industry verticals with BSCPAD.
                    </p>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
        {/*<div
          className="modal fade"
          id="team-popup-8"
          tabIndex="-1"
          aria-labelledby="team-popup-8Label"
          aria-hidden="true"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered pp-modal-team">
            <div className="modal-content">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <div className="modal-body">
                <Row className="mb-3">
                  <div className="col-md-6 text-center">
                    <div className="mb-3 pe-md-3">
                      <img
                        src={Innovion}
                        alt="team"
                        className="no-bdrs w-100 borras"
                      />
                    </div>
                    <p className="mb-1">
                      <img
                        src={Innovion}
                        alt="team"
                        className="no-bdrs"
                        height="40"
                      />
                    </p>
                    <p>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="#"
                      >
                        https://innovion.co
                      </a>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <h3>INNOVION</h3>
                    <p style={{ opacity: "0.6" }}>
                      Innovion has built a prestigious reputation with a unique
                      approach to guerilla marketing, collaborating with over
                      200 blockchain projects.
                    </p>
                    <p>
                      <a
                        className="me-3"
                        target="_blank"
                        rel="noreferrer"
                        href="#"
                      >
                        <em className="fab fa-linkedin-in"></em>
                      </a>
                    </p>
                    <hr />
                    <p>
                      Innovion will strengthen our Public reach and further grow
                      our client base.
                    </p>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>*/}
        <div id="tsparticles">
          <canvas
            className="tsparticles-canvas-el"
            width="1274"
            height="6186"
            style={{ width: "100%", height: "100%", pointerEvents: "initial" }}
          ></canvas>
        </div>
        <div
          className="modal fade in"
          id="helpModal"
          tabIndex="-1"
          aria-labelledby="helpModalLabel"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content modal-content text-white modal-help"
              style={{ backgroundColor: "rgb(26, 26, 26)" }}
            >
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close text-white"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  style={{ filter: "invert(1)" }}
                ></button>
              </div>
              <div className="modal-body">
                <div className="d-flex mb-3">
                  <a
                    className="btn btn-info me-2 w-100 text-white text-center"
                    href="https://link.trustwallet.com/open_url?coin_id=56&amp;url=https://bscpad.com/"
                  >
                    Open with{" "}
                    <img
                      alt=""
                      src={TrustPlatform}
                      width="30px"
                      className="me-2"
                    />
                  </a>
                </div>
                <h2 className="text-warning">
                  How to Set Up and Use Trust Wallet for BSCPAD.COM
                </h2>
                <h5 className="mt-3">
                  Setting up your wallet for Binance Smart Chain
                </h5>
                <ul className="ps-0" style={{ listStyle: "none" }}>
                  <li>
                    1). Download Trust Wallet. If you already have Trust Wallet,
                    make sure your app is up to date.
                  </li>
                  <li>
                    2). Complete{" "}
                    <a
                      href="https://community.trustwallet.com/t/how-to-create-a-multi-coin-wallet/41"
                      target="_blank"
                      rel="noreferrer"
                    >
                      basic setup of a multi-coin wallet
                    </a>
                    . Remember to save your backup phrases.
                  </li>
                  <li>
                    3). Go to your Smart Chain wallet and press receive to find
                    your address
                  </li>
                  <li>
                    4). That’s it! You’re ready to start using Binance Smart
                    Chain
                  </li>
                </ul>
                <h5 className="mt-4">Using BSCPAD.COM in Trust Wallet</h5>
                <ul className="ps-0" style={{ listStyle: "none" }}>
                  <li>
                    5). For this part, iOS users will need the Dapp browser.
                    Android users have the Dapp browser by default.
                  </li>
                  <li>
                    6). Once you’ve topped up your wallet, open the Dapp browser
                    by pressing on the four squares at the bottom of the app.
                  </li>
                </ul>
                <p className="text-center">
                  <img
                    className="mx-auto"
                    src={Help1}
                    alt=""
                    style={{ maxWidth: "97%" }}
                  />
                </p>
                <ul className="ps-0" style={{ listStyle: "none" }}>
                  <li>
                    7). Input <b>bscpad.com</b>
                  </li>
                  <li>8). Change network to Binance smart chain</li>
                  <li>9). Use the Dapp and have fun!</li>
                </ul>
                <h5 className="mt-5">
                  Enable DApp Browser on Trust Wallet (iOS version)
                </h5>
                <ul className="ps-0" style={{ listStyle: "none" }}>
                  <li>
                    <p>
                      1). Open&nbsp;<b>Safari Browser</b>&nbsp;and then type in
                      the URL:&nbsp;<b>trust://browser_enable</b>, then tap
                      on&nbsp;<b>Go</b>
                    </p>
                    <p>
                      <img
                        className="mx-auto"
                        src={Help2}
                        alt=""
                        style={{ maxWidth: "97%" }}
                      />
                    </p>
                  </li>
                  <li>
                    <p>
                      2). A prompt will appear that will ask if you want
                      to&nbsp;<b>Open this page in “Trust”?</b>, tap on&nbsp;
                      <b>Open</b>
                    </p>
                    <p>
                      <img
                        className="mx-auto"
                        src={Help3}
                        alt=""
                        style={{ maxWidth: "97%" }}
                      />
                    </p>
                    <p>
                      The&nbsp;<b>Trust Wallet</b>&nbsp;app will launch and
                      the&nbsp;<b>DApp&nbsp;browser</b>&nbsp;will be enabled
                    </p>
                    <p>
                      <img
                        className="mx-auto"
                        src={Help4}
                        alt=""
                        style={{ maxWidth: "97%" }}
                      />
                    </p>
                  </li>
                </ul>
                <div className="d-flex mt-4">
                  <a
                    className="btn btn-info me-2 w-100 text-white text-center"
                    href="https://link.trustwallet.com/open_url?coin_id=56&amp;url=https://bscpad.com/"
                  >
                    Open with{" "}
                    <img
                      alt=""
                      src={TrustPlatform}
                      width="30px"
                      className="me-2"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade "
          id="walletModal"
          tabIndex="-1"
          aria-labelledby="walletModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title text-dark" id="walletModalLabel">
                  Your wallet
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <h5
                    className="text-dark mb-2"
                    style={{ fontSize: "17px", wordBreak: "break-word" }}
                  >
                    <b></b>
                  </h5>
                  <a
                    href="https://bscscan.com/address/null"
                    target="_blank"
                    rel="noreferrer"
                    className="text-warning d-inline-flex align-items-center me-4"
                    style={{ textDecoration: "none" }}
                  >
                    <span className="me-1">View on BscScan</span>
                    <i className="mdi mdi-open-in-new"></i>
                  </a>
                  <a
                    className="text-warning d-inline-flex align-items-center"
                    href="#"
                    style={{ textDecoration: "none" }}
                  >
                    <span className="me-1">Copy Address</span>
                    <i className="mdi mdi-content-copy"></i>
                  </a>
                </div>
                <div className="text-center mt-4">
                  <a
                    href="#"
                    className="btn btn-outline-primary"
                    data-bs-dismiss="modal"
                  >
                    Logout
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span></span>
      </div>
    </>
  );
};

export default Landing;
